type ToggleChipsProps<T extends string> = {
  label: string
  values: T[]
  selected: T[]
  labelFor: (value: T) => string
  onChange: (values: T[]) => void
}

export default function ToggleChips<T extends string>({
  label,
  values,
  selected,
  labelFor,
  onChange,
}: ToggleChipsProps<T>) {
  const selectedSet = new Set(selected)

  const toggle = (value: T) => {
    if (selectedSet.has(value)) {
      if (selected.length === 1) return
      onChange(selected.filter((item) => item !== value))
      return
    }

    onChange([...selected, value])
  }

  return (
    <fieldset className="control-group">
      <legend>{label}</legend>
      <div className="chip-list">
        {values.map((value) => (
          <button
            type="button"
            key={value}
            className={selectedSet.has(value) ? 'chip active' : 'chip'}
            aria-pressed={selectedSet.has(value)}
            onClick={() => toggle(value)}
          >
            {labelFor(value)}
          </button>
        ))}
      </div>
    </fieldset>
  )
}
